import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@stockx/ui';
import { VERTICALS_WITH_GENDERS_ARR } from '@app/config';
import { EVENTS, trackEvent } from '@app/segment';
import { BrowseSwitcherLink, useRouter } from '@app/router';
import { useIsNonInteractiveViewer } from '@app/ui';
import {
  CategoryLinkStyles,
  StyledSwitcher,
  StyledSwitcherWrapper,
} from './MainNavigation.styles';
import SubNavigation from '../SubNavigation';

const MainNavigation = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const [isSubNavRendered, setIsSubNavRendered] = useState(
    isNonInteractiveViewer,
  );

  useEffect(() => {
    const handleRouteChange = () => setIsSubNavRendered(false);

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  });

  const VERTICALS_ARRAY = VERTICALS_WITH_GENDERS_ARR.map((vert) => ({
    ...vert,
    lowerCaseText: vert.text.toLowerCase(),
  }));

  const homepageVerticalText = {
    sneakers: t('Sneakers'),
    shoes: t('Shoes'),
    streetwear: t('Streetwear'),
    electronics: t('Electronics'),
    collectibles: t('Collectibles'),
    handbags: t('Handbags'),
    watches: t('Watches'),
    'trading cards': t('Trading Cards'),
    apparel: t('Apparel'),
    accessories: t('Accessories'),
    men: t('Men'),
    women: t('Women'),
    kids: t('Kids'),
  };

  const handleVerticalClick = (label) => {
    trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
      label,
    });
  };

  const options = VERTICALS_ARRAY.map((vertical) => (
    <CategoryLinkStyles
      key={vertical.lowerCaseText}
      updatedVertical={vertical.lowerCaseText}
      to={vertical.url}
      onClick={() => handleVerticalClick(vertical.text)}
      data-testid="vertical-switcher"
      onMouseEnter={() => {
        setIsSubNavRendered(true);
      }}
      _hover={{
        textDecoration: 'underline',
        textDecorationThickness: '2px',
        textUnderlineOffset: '3px',
      }}
    >
      <BrowseSwitcherLink
        to={vertical.url}
        updatedVertical={vertical.lowerCaseText}
        onClick={() => handleVerticalClick(vertical.text)}
      >
        {homepageVerticalText[vertical.lowerCaseText]}
      </BrowseSwitcherLink>
      {isSubNavRendered && <SubNavigation vertical={vertical?.lowerCaseText} />}
    </CategoryLinkStyles>
  ));

  return (
    <Box
      as="nav"
      aria-label="Product Category Switcher"
      data-testid="MainNavigation"
    >
      <StyledSwitcher>
        <StyledSwitcherWrapper>{options}</StyledSwitcherWrapper>
      </StyledSwitcher>
    </Box>
  );
};

export default MainNavigation;
